export default {
  path: '/system',
  title: '系统设置',
  icon: 'flash',
  hideSub: true,
  children: ((pre) => [
    { path: `${pre}/backupData`, title: '数据备份', icon: 'dot-circle-o' },
    { path: `${pre}/startStop`, title: '一键启停', icon: 'dot-circle-o' },
    { path: `${pre}/runMonitor`, title: '运行监控', icon: 'dot-circle-o' },
    { path: `${pre}/auditLog`, title: '审计日志', icon: 'dot-circle-o' },
  ])('/system')
}
